import { useForm, type UseFormReturn } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import type { FormConfig, FormKeys } from "~/lib/form/form-config-types";
import { formConfigToZodSchemas } from "~/lib/form/form-config-to-zod-schema";
import { formConfigToFormComponents } from "~/lib/form/form-config-to-form-components";
import { useI18n } from "./use-i18n";

export const loginFormConfig = {
  email: {
    type: "text",
    label: "Email",
    schema: z.string().trim().email({ message: "Please enter a valid email address" }),
    placeholder: "me@example.com",
  },
  accessCode: {
    type: "text",
    label: "Access Code",
    schema: z.string().trim().min(1, { message: "Please enter an access code" }),
    placeholder: "Your access code",
  },
} as const satisfies FormConfig;

export const useLoginForm = (args: {
  // onSubmit: (data: z.infer<typeof loginFormSchema>) => void;
  // defaultValues?: z.infer<typeof loginFormSchema>;
  // values?: z.infer<typeof loginFormSchema>;
  onSubmit: (data: any) => void;
  defaultValues?: any;
  values?: any;
}) => {
  const { l } = useI18n();
  const { default: loginFormSchema } = formConfigToZodSchemas(loginFormConfig, l);

  //
  // form
  //
  const form = useForm<z.infer<typeof loginFormSchema>>({
    resolver: zodResolver(loginFormSchema),
    defaultValues: args.defaultValues,
    values: args.values,
  });

  //
  // submitter
  //
  const onSubmit = form.handleSubmit(
    (data) => args.onSubmit(data),
    (e) => console.error("rhf error", e)
  );

  //
  // generate form components
  //
  const formComponents = formConfigToFormComponents({
    form,
    config: loginFormConfig,
    l,
  });

  return { form, formSchema: loginFormSchema, onSubmit, formComponents };
};
